<template>
  <v-container fluid>
    <v-card elevation="2" class="py-2" rounded>
      <v-card-text>
        <v-row>
          <h3>My Sandbox Applications</h3>
          <v-spacer/>
          <v-btn @click="dialog=!dialog" class="primary" ><v-icon>mdi-plus</v-icon>Create new Application</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat rounded class="mt-4">
      <v-divider/>
      <v-card-text v-if="applications && applications.length===0">
        You do not have any sandbox application at the moment!
      </v-card-text>
      <v-card-text v-else>
        <v-data-table
            :headers="headers"
            :items="applications"
        >
          <template v-slot:item.id="{index}">
            <span>{{index+1}}</span>
          </template>
          <!--start date-->
          <template v-slot:item.date_created="{item}">
            <span>{{helpers().formatDate(item.date_created) || 'N/A'}}</span>
          </template>
          <!--end date-->

          <!--start merchant-->
          <template v-slot:item.merchant="{ item }">
            <span>{{ item.merchant.name }}</span>
          </template>
          <!--end merchant-->
          
          <!--start scope-->
          <template v-slot:item.scope="{item}">
            <span>{{item.scope.name}}</span>
          </template>
          <!--end scope-->
          <!--start name-->
          <template v-slot:item.name="{item}">
            <span>{{item.application.name}}</span>
          </template>
          <!--end name-->
          <!--start name-->
          <template v-slot:item.client_type="{item}">
            <span>{{item.application.client_type}}</span>
          </template>
          <!--end name-->
          <!--start action-->
          <template v-slot:item.action="{item}">
            &nbsp;
            <v-btn @click="showCredentials(item)" class="red accent-1" small>Show Credentials</v-btn>
          </template>
          <!--end action-->
        </v-data-table>
      </v-card-text>
    </v-card>
    <!--START Create APP-->
    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Sandbox Application</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form  v-model="isValid" ref="sandboxForm">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                        label="Application Name*"
                        required
                        v-model="formData.app_name"
                        :rules="[rules.app_name.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                        label="Account Number*"
                        v-model="formData.account_number"
                        required
                        readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                        label="Callback URL*"
                        required
                        v-model="formData.callback_url"
                        class="mb-3"
                        :rules="[rules.callback_url.required]"
                    ></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                      md="12"
                  >
                    <v-select
                        :items="scopes"
                        v-model="formData.scope"
                        label="Select the service would you like to subscribe to*"
                        required
                        :item-text="item=>item.name"
                        :item-value="item=>item.name"
                        @copy.prevent
                        @paste.prevent
                        :rules="[rules.scope.required]"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small class="error--text">*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
            >
              Close
            </v-btn>
            <v-btn
                color="primary"
                @click="save"
                class="g-recaptcha"
                data-sitekey="reCAPTCHA_site_key"
                data-callback='onSubmit'
                data-action='submit'
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--END Create APP-->

    <!--BEGIN Show credentials-->
    <div class="text-center" v-if="Object.keys(appDetails).length>0">
      <v-dialog
          v-model="credentialsDialog"
          width="500"
      >

        <v-card>
          <v-card-title class="text-h5 grey lighten-4">
            {{ appDetails && appDetails.application.name }} App
          </v-card-title>
          <v-divider/>
          <v-card-title class="text-h5 grey lighten-2">
            <v-btn outlined @click="preview(appDetails.application)" color="error" small>Preview Sample Code</v-btn>
            <v-spacer/>
            <v-btn @click="downloadCode(appDetails.application)" color="primary" small>Download Sample Code</v-btn>
          </v-card-title>

          <v-card-text class="mt-5">
            <v-text-field
                label="Client ID"
                outlined
                title="Double Click to copy"
                :value="appDetails.application.client_id"
            />
            <v-text-field
                label="Client Secret"
                outlined
                title="Double Click to copy"
                :value="appDetails.application.client_secret"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                outlined
                @click="credentialsDialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!--BEGIN Show code snippets sample-->
    <div class="text-center" v-if="Object.keys(appDetails).length>0">
      <v-dialog
          v-model="credentialsDialog"
          width="500"
      >

        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            {{ appDetails && appDetails.application.name }} App
          </v-card-title>
          <v-divider/>
          <v-card-title class="text-h5 grey lighten-2">
            <v-btn outlined @click="preview(appDetails.application)" color="error" small><v-icon small>mdi-printer-eye</v-icon> Preview Sample Code</v-btn>
            <v-spacer/>
            <v-btn @click="downloadCode(appDetails.application)" color="primary" small><v-icon small>mdi-cloud-download</v-icon> Download Sample Code</v-btn>
          </v-card-title>

          <v-card-text class="mt-5">
            <v-text-field
                label="Client ID"
                outlined
                title="Double Click to copy"
                :value="appDetails.application.client_id"
            />
            <v-text-field
                label="Client Secret"
                outlined
                title="Double Click to copy"
                :value="appDetails.application.client_secret"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                outlined
                @click="credentialsDialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!--BEGIN preview code sample-->
    <div class="text-center" v-if="Object.keys(appDetails).length>0">
      <v-dialog
          v-model="previewDialog"
          width="800"
      >

        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            {{ appDetails && appDetails.application.name }} Code Sample
            <v-spacer/>
            <v-btn @click="downloadCode(appDetails.application)" color="primary" outlined small><v-icon small>mdi-cloud-download</v-icon> Download</v-btn>
          </v-card-title>

          <v-card-text class="mt-5">
            <code-editor
                :read_only="true"
                theme=""
                v-model="code"
                :wrap_code="false"
                :language_selector="false"
                class="github_dark"
                :copy_code="true"
                font_size="14px"
                width="100%"
                :languages="[['php','PHP']]"
            ></code-editor>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="error"
                outlined
                @click="previewDialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <!--END preview code sample-->
  </v-container>
</template>

<script>
import {mapActions} from "vuex";
import helpers from "../../../../shared/utilities/helpers";
import generateAuthCode from "../../../../shared/snippets/auth/GenerateAuthCode";

export default {
  name: "DashboardCardSandbox",
  beforeRouteEnter(to,from,next){
    next(v=>{
      v.$store.dispatch("Dashboard/getApplications",{isLive:false})
      v.$store.dispatch("Dashboard/getScopes")
    })
  },
  data: () => ({
    show: false,
    //
    code:"",
    //
    dialog: false,
    credentialsDialog: false,
    previewDialog: false,
    appDetails: {},
    isValid:false,
    formData: {
      environment:"SANDBOX",
      app_name:"",
      account_number:"600980",
      scope:"",
      callback_url:""
    },
    headers: [
      {
        text: '#S/N',
        align: '',
        sortable: true,
        value: 'id'
      },
      {
        text: 'Created On',
        align: '',
        sortable: true,
        value: 'date_created'
      },
      {
        text: 'Merchant',
        align: '',
        sortable: true,
        value: 'merchant'
      },
      {
        text: 'Account Number',
        align: '',
        sortable: true,
        value: 'account_number'
      },
      {
        text: 'Scope',
        align: '',
        sortable: true,
        value: 'scope'
      },
      {
        text: 'Name',
        align: '',
        sortable: true,
        value: 'name'
      },
      {
        text: 'Client Type',
        align: '',
        sortable: true,
        value: 'client_type'
      },
      {
        text: 'Actions',
        align: '',
        sortable: true,
        value: 'action'
      },
    ],
    rules: {
      app_name: {
        required: (value) => !!value || 'Application name is Required.',
      },
      scope: {
        required: (value) => !!value || 'Scope is required.',
      },
      callback_url: {
        required: (value) => !!value || 'Callback URL is required.',
      }
    },
  }),
  computed:{
    applications(){
      return this.$store.getters['Dashboard/DashboardGetter']("applications")
    },
    scopes(){
      return this.$store.getters['Dashboard/DashboardGetter']("scopes")
    },
  },
  methods:{
    helpers() {
      return helpers
    },
    ...mapActions({
      save: function (dispatch) {
        if (!this.isValid) {
          this.$refs.sandboxForm.validate()
          this.submitting = false;
        } else {
          dispatch('Dashboard/createApplications', {...this.formData})
          setTimeout(()=>{
            this.dialog=false
          },1000)
        }
      }
    }),
    showCredentials(item) {
      this.credentialsDialog=!this.credentialsDialog
      this.appDetails=item
    },
    preview() {
      this.previewDialog=true
      this.importAuthSnippets()
    },
    downloadCode(item) {
      //
      helpers.downloadFile('auth',generateAuthCode(item))
    },
    importAuthSnippets(){
      this.code=generateAuthCode(this.appDetails?.application)
    },
  },
}
</script>
